import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { KTSVG } from 'src/_metronic/helpers';
import { IVendorReconciliation, useVendorReconciliationApprove } from '../../services';
import { ObjectionModal } from '../modals/vendor-reconciliation/objection';

type Props = {
  data: IVendorReconciliation;
};

export default function VendorReconciliation({ data }: Props) {
  const queryClient = useQueryClient();
  const [isObjectionModal, setIsObjectionModal] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(false);

  const onError = (err: any) => {
    toast.error(err.response?.data?.detail || err.response?.data?.message || err?.message || 'Dosya yüklenirken bir hata oluştu', { autoClose: 2000 });
  };

  const onSuccessApprove = (response: any) => {
    setIsOpen(false);
    toast.success('Mutabakat işleminiz başarıyla gerçekleştirildi.', { autoClose: 1000 });
    setTimeout(() => {
      queryClient.invalidateQueries(['vendor-reconciliation']);
    }, 500);
  };

  const { mutateAsync: mutateApprove, isLoading: isLoadingApprove } = useVendorReconciliationApprove(onSuccessApprove, onError);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 500);

    return () => clearTimeout(timer); // Component unmount olursa temizle
  }, []); // isOpen değiştiğinde çalışır

  return (
    <>
      <div className={`vendor-drawer ${isOpen ? 'open' : ''}`}>
        {/* Sol Taraftaki İkon */}
        <div className="drawer-icon" onClick={() => setIsOpen(!isOpen)} role="button">
          <KTSVG
            path={`${isOpen ? '/media/icons/duotone/Navigation/Angle-double-right.svg' : '/media/icons/duotone/Navigation/Angle-double-left.svg'}`}
            className="svg-icon-2 svg-icon-white"
          />
        </div>

        {/* İçerik */}
        <div className="drawer-content card hover-elevate-up shadow-sm parent-hover bg-white">
          <div className="card-body px-3 py-4">
            <p className="mb-1 text-dark fs-7 mb-4">{data?.message}</p>
            <div className="d-flex  flex-column">
              <div className="d-flex align-items-center gap-5 mb-4">
                <button className="btn btn-icon btn-light-success btn-sm" type="button" onClick={() => mutateApprove({ vendorReconciliation: data?.id })}>
                  {isLoadingApprove ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <KTSVG path={`/media/icons/duotone/Navigation/Check.svg`} className="svg-icon-2 svg-icon-white" />
                  )}
                </button>
                <span>Mutabıkız.</span>
              </div>
              <div className="d-flex align-items-center gap-5 mb-4">
                <button type="button" className="btn btn-icon btn-light-danger btn-sm" onClick={() => setIsObjectionModal(true)}>
                  <KTSVG path={`/media/icons/duotone/Navigation/Close.svg`} className="svg-icon-2 svg-icon-white" />
                </button>
                <span>Mutabık değiliz.</span>
              </div>
              <span className="fs-9 text-muted">7 gün içerisinde cevap verilmediği durumda mutabık kalındı olarak işaretlenecektir.</span>
            </div>
          </div>
        </div>
      </div>
      <ObjectionModal show={isObjectionModal} handleClose={() => setIsObjectionModal(!isObjectionModal)} data={data} />
    </>
  );
}
